const SILENT_SCROLL_ADJUSTMENT_EVENT = 'sf-silent-scroll-adjustment';

/**
 * Adjusts a container's scrollTop programmatically — e.g. to preserve the viewport across list
 * prepends — without it counting as user scrolling: scroll indicators subscribed via
 * onSilentScrollAdjustment re-baseline instead of deriving a scroll direction from the jump
 * (which would e.g. hide a reveal header while the user is actually scrolling up).
 */
export const adjustScrollTopSilently = (container: HTMLElement, delta: number) => {
  if (delta === 0) return;
  container.scrollTop += delta;
  // Dispatched synchronously — the native scroll event this assignment queues arrives later,
  // so subscribers can re-baseline before they process it.
  container.dispatchEvent(new CustomEvent(SILENT_SCROLL_ADJUSTMENT_EVENT));
};

/** Subscribes to silent scroll adjustments on a container. Returns the unsubscribe function. */
export const onSilentScrollAdjustment = (container: HTMLElement, listener: () => void) => {
  container.addEventListener(SILENT_SCROLL_ADJUSTMENT_EVENT, listener);
  return () => container.removeEventListener(SILENT_SCROLL_ADJUSTMENT_EVENT, listener);
};
